const getMatchOpponents = (match: TournamentBracketMatch): BracketMatchOpponent[] => {
  const { opponents } = match;

  if (opponents.length === 0) {
    opponents.push({
      acronym: 'TBD',
      id: match.id * 1000 + 1, // allow to have a unique ID by TBD opponent
      image_url: '',
      dark_mode_image_url: '',
      name: 'TBD',
      score: null,
      slug: 'tbd'
    });
  }

  if (opponents.length === 1) {
    opponents.push({
      acronym: 'TBD',
      id: match.id * 1000 + 2, // allow to have a unique ID by TBD opponent
      image_url: '',
      dark_mode_image_url: '',
      name: 'TBD',
      score: null,
      slug: 'tbd'
    });
  }

  return opponents;
};

export { getMatchOpponents };
